const portretten = [
  {
    name: 'Voorbeeld Portret',
    description: [
      'Uniek 3D-geprint portret, gemaakt op basis van jouw favoriete foto. Een minimalistisch en persoonlijk kunstwerk, met zorg en precisie vormgegeven. Perfect als bijzonder cadeau of waardevol aandenken. Verkrijgbaar in diverse kleuren en formaten.',
      'Een portret laten maken? Stuur een foto en ontdek de mogelijkheden!',
    ],
    dimensions: '250x40x120mm',
    images: [
      require('../../images/portretten/portretten_1A.png'),
      require('../../images/portretten/portretten_1C.jpg'),
      require('../../images/portretten/portretten_1B.png'),
    ],
    stl: '/products/portretten/voorbeeld-portret.stl',
    contactLink: '/contact?product=Voorbeeld%20Portret',
    price: '29,99',
  },
  // Voeg hier meer portretten toe
];

export default portretten; 